import en from './en/messages.js';
import fr from './fr/messages.js';
import pseudo from './pseudo/messages.js';

export default {
  en,
  fr,
  pseudo
};
